// extracted by mini-css-extract-plugin
module.exports = {"style":"style___2ZHlw","header":"header___2IdHI","content":"content___3ND7f","drawerBody":"drawerBody___36-zt","loading":"loading___1xwA7"};